import { Tag } from 'antd';
import DashboardCard from 'components/DashboardCard';
import React from 'react';
import { Module } from 'shared/prisma/types';
import { FormattedRelativeTime } from 'react-intl';
import { dayjs } from 'shared/utils/date';
import selectUnit from 'shared/utils/selectUnit';

function getStats(sessionRecording) {
  if (sessionRecording) {
    return [
      {
        title: 'Sample rate',
        value: sessionRecording.sampleRate,
        suffix: '%',
      },
      { title: 'Samples', value: sessionRecording.samples[0] },
      {
        title: 'Last sample',
        value: sessionRecording.lastSample && dayjs(sessionRecording.lastSample).toDate(),
        formatter: time => (time ? <FormattedRelativeTime {...selectUnit(time)} /> : '-'),
      },
    ];
  }

  return [];
}

const SessionRecordingCard = ({ dataSourceId, sessionRecording, canEdit }) => {
  const websiteStats = getStats(sessionRecording);

  return (
    <DashboardCard
      title={sessionRecording.name}
      period="Last 30 days"
      extra={[<Tag>Session recording</Tag>]}
      statistics={websiteStats}
      module={Module.Heatmaps}
      resultsUrl={`/data-sources/${dataSourceId}/hsr/session-recordings/${sessionRecording.matomoHsrId}`}
      manageUrl={canEdit && `/data-sources/${dataSourceId}/hsr/manage-session-recordings`}
    />
  );
};

export default SessionRecordingCard;
